// cSpell:enableCompoundWords
import GameItem from 'components/tabs/gameselect/components/gameitem/GameItem';
import SectionHeader from 'components/tabs/gameselect/components/sectionheader/SectionHeader';
import useLobbyManager from 'hooks/useLobbyManager';
import React from 'react';
import styles from './GamesSection.module.scss';

type JoinGamesSectionProps = {
  className?: string;
};

const JoinGamesSection: React.FC<JoinGamesSectionProps> = ({ className = '' }) => {
  const baseCls = `${styles.SectionList} ${styles.SectionListColumn} ${className}`;

  const { joinGamesList, onJoinGame } = useLobbyManager();

  return (
    <>
      {joinGamesList.length > 0 && (
        <div className={baseCls}>
          <SectionHeader />
          {joinGamesList.map((game) => {
            return <GameItem key={game.sqGameId} game={game} onGameClicked={onJoinGame} />;
          })}
        </div>
      )}
    </>
  );
};

export default JoinGamesSection;
